import * as React from 'react';

const AmountBathrooms = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M11.625 12.875h8.75l-.553 3.322a5 5 0 0 1-4.933 4.178H7.111a5 5 0 0 1-4.933-4.178l-.553-3.322h3.75" />
            <path d="M11 17.875H6a.625.625 0 0 1-.625-.625v-4.375c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25v4.375c0 .345-.28.625-.625.625M14.125 4.125a2.5 2.5 0 1 1 5 0v8.75" />
            <path d="M11.625 6.625a2.5 2.5 0 1 1 5 0z" />
        </g>
    </svg>
);
export default AmountBathrooms;
